import React from 'react';
import { GetServerSidePropsContext, GetServerSidePropsResult } from 'next';
import * as seline from '@seline-analytics/web';

import PageLayout from '../components/blocks/page-layout';
import graphqlClient from '../utils/graphql-client';
import { captureException } from '@sentry/nextjs';
import { CategoryObjectType, ProductObjectTypePaginated, ShopObjectType } from '../../generated/graphql';
import { SHOP_ID } from '../constants';
import Categories from '../components/blocks/categories';
import useBrowserEffect from '../hooks/useBrowserEffect';
import Title from '../components/elements/title';
import { useTranslate } from '../hooks/useTranslate';

type Props = {
  shop?: ShopObjectType;
  newArrivals?: ProductObjectTypePaginated;
  categories: Array<CategoryObjectType>;
  error?: Error | null;
};

const listProductsQuery = `query ListAllCategoriesQuery {
  listCategories(inStock: true) {
    _id
    name {
      nl
      fr
    }
    picture
    showOnOverview
    createdAt
    updatedAt
  }
}`;

export default function Page(props: Props) {
  const { categories } = props;
  const translate = useTranslate();

  useBrowserEffect(() => {
    seline.track('View categories');
  });

  return (
    <PageLayout title={translate('categories')}>
      <Title>{translate('categories')}</Title>
      <Categories categories={categories} />
    </PageLayout>
  );
}

export const getServerSideProps = async (ctx: GetServerSidePropsContext): Promise<GetServerSidePropsResult<Props>> => {
  const {res} = ctx;
  let categories: Array<CategoryObjectType> = [];
  let error: Error | null = null;

  try {
    let res = await graphqlClient.request<{
      listCategories: Array<CategoryObjectType>;
    }>(listProductsQuery, {
      shopId: SHOP_ID,
    });

    categories = res.listCategories || [];
  } catch (err: any) {
    captureException(err);
    error = err;
  }

  res.setHeader(
    'Cache-Control',
    'public, s-maxage=10, stale-while-revalidate=59'
  )

  return {
    props: {
      categories,
      error,
    },
  };
}
